import { render, staticRenderFns } from "./UpdateEstimatedDuration.vue?vue&type=template&id=22035ae3"
import script from "./UpdateEstimatedDuration.vue?vue&type=script&lang=js"
export * from "./UpdateEstimatedDuration.vue?vue&type=script&lang=js"
import style0 from "./UpdateEstimatedDuration.vue?vue&type=style&index=0&id=22035ae3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports